import request from '@/libs/request'
// 登录
export function login (data) {
  return request({
    url: `login`,
    method: 'post',
    data
  })
}
// 用户列表
export function userList (data) {
  return request({
    url: `user/list`,
    method: 'get',
    params: data
  })
}
// 用户列表
export function userClassList (data) {
  return request({
    url: `user/userClassList`,
    method: 'get',
    params: data
  })
}
// 改变用户状态
export function changeUserStatusApi (data) {
  return request({
    url: `user/changeStatus`,
    method: 'post',
    data: data
  })
}

// 返回权限
export function getUserInfo () {
  return request({
    url: 'getAuth',
    method: 'get'
  })
}

// 用户信息
export function userInfo (id) {
  return request({
    url: `user/info/${id}`,
    method: 'get'
  })
}

// 升级日志
export function levelLogList (data) {
  return request({
    url: `level/log`,
    method: 'get',
    params: data
  })
}

export function getAllRole (user_id) {
  return request({
    url: `user/getAllRole/${user_id}`,
    method: 'get'
  })
}

export function userEdit (data) {
  return request({
    url: `user/edit`,
    method: 'post',
    data
  })
}
// 排名
export function getRanking (data) {
  return request({
    url: `user/ranking`,
    method: 'get',
    params: data
  })
}
export function unlock (id) {
  return request({
    url: `user/unlock/${id}`,
    method: 'post'
  })
}

export function exportData (data) {
  return request({
    url: `user/exportInfos`,
    method: 'post',
    data
  })
}

export function getAllCardInfo (data) {
  return request({
    url: `user/getAllCardInfo`,
    method: 'get'
  })
}

export function getAllCoupon () {
  return request({
    url: `user/getAllCoupon`,
    method: 'get'
  })
}
export function addCoupon (data) {
  return request({
    url: `user/addCoupon`,
    method: 'post',
    data
  })
}
export function getAllCard () {
  return request({
    url: `user/getAllCard`,
    method: 'get'
  })
}
export function sendCard (data) {
  return request({
    url: `user/addCard`,
    method: 'post',
    data
  })
}
